var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 78,
    viewBox: "0 0 74 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_28639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.03125 13.0534L36.1085 0.199219L73.1574 12.8249L67.1586 60.5569L36.1085 77.753L5.5443 60.7854L0.03125 13.0534Z",
    fill: "#E23237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1543 12.8249L36.1055 0.199219V77.753L67.1555 60.5856L73.1543 12.8249Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1639 9.25586L13.6836 59.2731L22.0815 59.1303L26.5949 47.8469H46.7616L51.7034 59.2731L59.73 59.4159L36.1639 9.25586ZM36.2213 25.2808L43.8194 41.1627H29.5368L36.2213 25.2808Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_28639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.4136,
    height: 78,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg14);
export default __webpack_public_path__ + "static/media/img14.4729182b65f1dc1a0bdfc4abfb7f9d03.svg";
export { ForwardRef as ReactComponent };